import { alpha, IconButton, styled } from '@mui/material'
import { ReloadIcon } from '@weblite/icons'

export function Retry({
  show,
  onRetry,
}: {
  show: boolean
  onRetry: () => unknown
}) {
  return (
    <>
      {show && (
        <Root onClick={onRetry}>
          <ReloadIcon
            sx={{ width: '56px', height: '56px', color: 'neutral000' }}
          />
        </Root>
      )}
    </>
  )
}

const Root = styled(IconButton)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${({ theme }) => alpha(theme.palette.neutral1000, 0.3)};
  &:hover {
    background-color: ${({ theme }) => alpha(theme.palette.neutral1000, 0.3)};
  }
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 50px;
  width: auto;
  height: auto;
`
